export default "__VITE_PUBLIC_ASSET__57391903__"